export default __webpack_public_path__ + "static/media/mercedbarranquilla.a5f7f239.jpg";